module.exports = __webpack_public_path__ + "static/media/1920x433.10eb99f7.jpg";